module.exports = __webpack_public_path__ + "static/media/leaderboard.28ef5b81.png";